export const scenes = [
  {
    title: 'Scene #1',
    frames: [
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-000.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-001.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-002.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-003.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-004.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-005.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-006.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-007.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-008.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-009.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-001/frames/frame-010.json'
    ],
    annotations: 'https://static.scale.com/lidar-viewer/waterloo/la-001/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #2',
    frames: [
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-000.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-001.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-002.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-003.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-004.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-005.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-006.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-007.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-008.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-009.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-002/frames/frame-010.json'
    ],
    annotations: 'https://static.scale.com/lidar-viewer/waterloo/la-002/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #3',
    frames: [
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-000.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-001.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-002.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-003.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-004.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-005.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-006.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-007.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-008.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-009.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-003/frames/frame-010.json'
    ],
    annotations: 'https://static.scale.com/lidar-viewer/waterloo/la-003/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #4',
    frames: [
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-000.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-001.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-002.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-003.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-004.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-005.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-006.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-007.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-008.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-009.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-004/frames/frame-010.json'
    ],
    annotations: 'https://static.scale.com/lidar-viewer/waterloo/la-004/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #5',
    frames: [
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-000.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-001.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-002.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-003.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-004.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-005.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-006.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-007.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-008.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-009.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-005/frames/frame-010.json'
    ],
    annotations: 'https://static.scale.com/lidar-viewer/waterloo/la-005/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #6',
    frames: [
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-000.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-001.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-002.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-003.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-004.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-005.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-006.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-007.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-008.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-009.json',
      'https://static.scale.com/lidar-viewer/waterloo/la-006/frames/frame-010.json'
    ],
    annotations: 'https://static.scale.com/lidar-viewer/waterloo/la-006/annotations.json',
    showImages: true,
    frame: 0
  }
];

export default scenes;
